var _jsxFileName = "/builds/ccm-innovation/ccm-2.0/address-components/src/components/AddressPicker/SuggestedAddressModal.js";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ReactModal from 'react-modal';
import './SuggestedAddressModal.css';

var SuggestedAddressModal = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SuggestedAddressModal, _Component);

  function SuggestedAddressModal(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      selectedSuggestedAddress: null,
      noSuggestedAddresses: null
    };
    return _this;
  }

  var _proto = SuggestedAddressModal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var suggestedAddresses = this.props.suggestedAddresses;
    if (suggestedAddresses && suggestedAddresses.length > 0) this.setState({
      noSuggestedAddresses: true
    });
  };

  _proto.handleEditEnteredAddressClicked = function handleEditEnteredAddressClicked() {
    this.props.closeModal();
    this.setState({
      selectedSuggestedAddress: null
    });
  };

  _proto.handleUseEnteredAddressClicked = function handleUseEnteredAddressClicked() {
    this.setState({
      selectedSuggestedAddress: null
    });
    var updatedEnteredAddress = this.props.enteredAddress;
    updatedEnteredAddress.addressVerified = false;
    this.props.handleAddressSelected(updatedEnteredAddress);
  };

  _proto.handleSuggestedAddressSelected = function handleSuggestedAddressSelected(selectedSuggestedAddress) {
    this.setState({
      selectedSuggestedAddress: selectedSuggestedAddress
    });
  };

  _proto.handleSuggestedAddressClicked = function handleSuggestedAddressClicked(selectedSuggestedAddressString) {
    var selectedSuggestedAddress = JSON.parse(selectedSuggestedAddressString);
    selectedSuggestedAddress.addressVerified = true;
    this.props.handleAddressSelected(selectedSuggestedAddress);
    this.setState({
      selectedSuggestedAddress: null
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        style = _this$props.style,
        isOpen = _this$props.isOpen,
        enteredAddress = _this$props.enteredAddress,
        suggestedAddresses = _this$props.suggestedAddresses,
        warningIcon = _this$props.warningIcon;
    var modalWidth = style.modalWidth;
    var _this$state = this.state,
        selectedSuggestedAddress = _this$state.selectedSuggestedAddress,
        noSuggestedAddresses = _this$state.noSuggestedAddresses;
    var suggestedAddressesOptions = [];
    suggestedAddresses.forEach(function (addressOption) {
      var value = addressOption.value;
      suggestedAddressesOptions.push({
        value: "" + JSON.stringify(value),
        label: value.line1 + " " + value.city + ", " + value.state + " " + value.zip,
        render: /*#__PURE__*/React.createElement("span", {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: 'address-line-one',
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 71,
            columnNumber: 13
          }
        }, value.line1, " ", /*#__PURE__*/React.createElement("i", {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 72,
            columnNumber: 29
          }
        }, value.suiteList ? '<apt, unit, etc.>' : '')), /*#__PURE__*/React.createElement("br", {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74,
            columnNumber: 13
          }
        }), /*#__PURE__*/React.createElement("span", {
          className: 'address-line-two',
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 13
          }
        }, value.city, ", ", value.state, " ", value.zip))
      });
    });
    return /*#__PURE__*/React.createElement(ReactModal, {
      isOpen: isOpen,
      style: style,
      className: "suggestion-modal " + modalWidth,
      overlayClassName: 'suggestion-modal-overlay',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-container',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-header',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-row suggestion-modal-section',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: warningIcon,
      alt: "Warning Icon",
      className: 'suggestion-modal-warning-icon',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("h2", {
      className: 'suggestion-modal-header-text',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 17
      }
    }, "Address Validation")))), /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-row suggestion-modal-section',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 109,
        columnNumber: 11
      }
    }, noSuggestedAddresses ? /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 112,
        columnNumber: 17
      }
    }, "We were unable to validate the address provided. You may continue with this address or use a suggested address below.") : /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 17
      }
    }, "We were unable to validate your address.", /*#__PURE__*/React.createElement("br", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 60
      }
    }), "If you are sure it is correct, please confirm below.")), noSuggestedAddresses && /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-row suggestion-modal-section',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 121,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'suggested-address',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 122,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: 'suggestion-modal-section-text',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 19
      }
    }, "Suggested addresses"), /*#__PURE__*/React.createElement("div", {
      className: "suggested-address-list",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 19
      }
    }, suggestedAddressesOptions.length > 0 && suggestedAddressesOptions.map(function (option) {
      return /*#__PURE__*/React.createElement("p", {
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement("label", {
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 130,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement("input", {
        name: 'Suggested Address List',
        value: option.value,
        onChange: function onChange() {
          return _this2.handleSuggestedAddressSelected(option.value);
        },
        type: "radio",
        label: option.label,
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 131,
          columnNumber: 27
        }
      }), option.render));
    })), /*#__PURE__*/React.createElement("button", {
      className: 'suggestion-modal-button',
      disabled: selectedSuggestedAddress === null,
      style: {
        backgroundColor: selectedSuggestedAddress === null ? '#b6b6b6' : null
      },
      onClick: function onClick() {
        return _this2.handleSuggestedAddressClicked(selectedSuggestedAddress);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145,
        columnNumber: 19
      }
    }, "Use suggested address"))), /*#__PURE__*/React.createElement("div", {
      className: 'suggestion-modal-row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: 'entered-address',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 160,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: 'suggestion-modal-section-text',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 162,
        columnNumber: 15
      }
    }, "You entered"), /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 164,
        columnNumber: 15
      }
    }, enteredAddress.line1, ", ", /*#__PURE__*/React.createElement("br", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 164,
        columnNumber: 42
      }
    }), " ", enteredAddress.city, ", ", enteredAddress.state, " ", enteredAddress.zip), /*#__PURE__*/React.createElement("button", {
      className: 'suggestion-modal-button',
      onClick: function onClick() {
        return _this2.handleUseEnteredAddressClicked();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 15
      }
    }, "Use entered address"), /*#__PURE__*/React.createElement("button", {
      className: 'suggestion-modal-button',
      onClick: function onClick() {
        return _this2.handleEditEnteredAddressClicked();
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 172,
        columnNumber: 15
      }
    }, "Edit")))));
  };

  return SuggestedAddressModal;
}(Component);

export { SuggestedAddressModal as default };
SuggestedAddressModal.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object.isRequired,
  enteredAddress: PropTypes.object.isRequired,
  suggestedAddresses: PropTypes.array.isRequired,
  handleAddressSelected: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  warningIcon: PropTypes.string.isRequired
} : {};